import { API } from "@/main.js";
import url from "@/assets/img_avatar.png";

const state = {
  client: "",
  licenseID: "",
  licenseStart: "",
  licenseEnd: "",
  modules: {
    design: false,
    budgeting: false
  }
};

const getters = {
  designEnabled: state => state.modules.design
};

const actions = {
  getLicense({ commit }) {
    return new Promise((resolve, reject) => {
      API.license.getLicense(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editLicense({ commit }, updatedData) {
    return new Promise((resolve, reject) => {
      API.license.edit(
        updatedData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

const mutations = {};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/license.js